import { defineMessages } from 'react-intl';

const enumMessages = defineMessages({
    CREATE_DISPUTE_FORM_ARN: {
        id: 'ReportDisputeDialog.arn',
        defaultMessage: 'Acquirer reference number is a required field',
    },
    CREATE_DISPUTE_FORM_DISPUTE_DUE_TO: {
        id: 'ReportDisputeDialog.reason',
        defaultMessage: 'Reason is a required field',
    },
    CREATE_DISPUTE_FORM_MODALITY: {
        id: 'ReportDisputeDialog.type',
        defaultMessage: 'Type is a required field',
    },
});

export default enumMessages;
